import React from 'react'
import styles from './FormLabel.module.scss'

export function FormLabel(props: {children: React.ReactNode}) {
  return (
    <label className={styles.label}>
        {props.children}
    </label>
  )
}
